import { useSyncExternalStore } from "react";
import { getUploadStatusSnapshot, subscribeUploadStatus, type UploadStatusState } from "../state/upload-status";

/** Subscribe to the global submission-upload status (see state/upload-status). */
export function useUploadStatus(): UploadStatusState {
    return useSyncExternalStore(subscribeUploadStatus, getUploadStatusSnapshot, getUploadStatusSnapshot);
}
